import {
  getBaseState,
  getEntityAdapterReducers,
  handleFulfilledAction,
  handleMultipleLoadingActions,
} from '@hwm/ui-lib';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { EntityReducers } from '../../EntityReducers';
import { thunks } from './SurveyMeasurementsThunks';
import { ISurvey } from '@models/ISurvey';

const entityAdapter = createEntityAdapter({
  selectId: (survey: ISurvey) => survey.id,
});

const slice = createSlice({
  name: EntityReducers.surveyMeasurements,
  initialState: {
    ...getBaseState(entityAdapter),
  },
  reducers: {
    ...getEntityAdapterReducers(entityAdapter),
  },
  extraReducers: (builder) => {
    handleMultipleLoadingActions([thunks.getSurveyMeasurements], builder);
    handleFulfilledAction(thunks.getSurveyMeasurements, builder, (state, payload) => {
      entityAdapter.setAll(state, payload);
    });
  },
});

export const surveyMeasurementsReducer = {
  slice,
  entityAdapter,
  thunks,
};
